import { render, staticRenderFns } from "./MobileNormPicker.vue?vue&type=template&id=2a4b101b&lang=html&"
import script from "./MobileNormPicker.vue?vue&type=script&lang=js&"
export * from "./MobileNormPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports